<template>
  <div v-if="preparado()">

    <div v-if="familia.impago && ! admin" class="alert alert-danger" role="alert">
      <p>¡ATENCIÓN! Estáis en situación de impago, y no podréis inscribiros a actividades
      extraescolares hasta regularizar la situación. Por favor, pincha en "Ver cuentas"
      y mira el "Saldo actual" para saber qué cantidad está pendiente de pago. Dicha
      cantidad deberá ser transferida a la cuenta del AMPA:</p>
      <ul>
        <li>Titular: APA DEL COLEGIO PUBLICO PABLO PICASSO</li>
        <li>Cuenta: ES54 0049 3279 5521 1452 9470</li>
      </ul>
    </div>

    <template v-if="! admin">
    <div v-if="periodoAbierto" class="alert alert-success" role="alert">
      <p class="mb-0">
      Se pueden solicitar altas y bajas para el siguiente período: {{ periodoAbierto.nombre }}.<br />
      Recuerda pulsar en "Editar actividades"  debajo de la persona correspondiente.
      </p>
    </div>
    <div v-else class="alert alert-warning" role="alert">
      <p class="mb-0">Actualmente no hay ningún período abierto para solicitar altas y bajas.</p>
    </div>
    </template>

    <template v-if="false">
    <div v-if="! admin" class="alert alert-success" role="alert">
      <p>¡Bienvenidos al nuevo curso 2023/2024!</p>
      <p>Podéis consultar toda la información sobre las actividades en el botón "Cuadro de extraescolares". Para realizar la inscripción hay que pulsar "Editar actividades" en la persona correspondiente.</p>
    </div>

    <div v-if="! admin" class="alert alert-warning" role="alert">
      <p>En el curso 2023/2024 hemos modificado las normas, y estos son los dos cambios introducidos:</p>
      <ul>
        <li>La inscripción en una actividad extraescolar implica la cesión de los datos de contacto (teléfono, email) a los profesores y empresas que imparten la actividad.</li>
        <li>Para asignar las plazas con actividades que tengan un máximo de alumnos, se tendrá en cuenta el orden de inscripción.</li>
        <li>Las cuotas de las actividades extraescolares volverán a pasarse a mes corriente (a inicio del mes correspondiente), salvo Primeros del Cole y Club de la Tarde que se seguirán pasando a mes vencido.</li>
      </ul>
    </div>
    </template>

    <div class="row">
      <div class="col-12">
        <div class="card mb-3">
          <h5 class="card-header">Datos generales</h5>
          <div class="card-body">
            <b>Núm. socio:</b> {{ familia.num_socio }}<br />
            <template v-if="admin">
            <b>Adscripción:</b> {{ familia.adscripcion }}<br />
            <b>Fecha de alta:</b> {{ familia.fecha_alta }}<br />
            <template v-if="familia.fecha_baja"><b>Fecha de baja:</b> {{ familia.fecha_baja }}<br /></template>
            </template>
            <template v-if="familia.observaciones">
            <b>Observaciones:</b> {{ familia.observaciones }}<br />
            </template>

            <b>Estado: </b>
            <template v-if="familia.impago"><span class="text-danger">Impago</span></template>
            <template v-else-if="familia.activos"><span class="text-success">Activo</span></template>
            <template v-else><span class="text-danger">Inactivo</span></template>
            <br />

            <template v-if="admin">
            <b>Renovación: </b>
            <template v-if="familia.fecha_renovacion"><span class="text-success">{{ familia.fecha_renovacion }}</span><br /></template>
            <template v-else><span class="text-danger">Pendiente (desde {{ familia.ultima_renovacion }})</span><br /></template>
            </template>

            <b>Modo de pago: </b>
            <template v-if="familia.domiciliacion">Domiciliación bancaria</template>
            <template v-else>Transferencia</template>
            <br />

            <template v-if="familia.domiciliacion">
            <b>Número de cuenta:</b> {{ familia.domiciliacion.iban }}
            <template v-if="familia.domiciliacion.estado == 2"> (inactiva)</template>
            <br />
            <template v-if="admin">
            <template v-for="p in familia.miembros">
            <template v-if="familia.domiciliacion.titular == p.id">
            <span :key="p.id">
            <b>Titular de la cuenta:</b> {{ p.nombre }} {{ p.apellidos }}<br />
            </span>
            </template>
            </template>
            <b>Ref. mandato:</b> {{ familia.domiciliacion.referencia }}<br />
            </template>
            </template>

            <p>
            <template v-if="familia.impago"><button type="button" class="btn btn-primary mt-3 mr-1" title="Impago" v-b-popover.click.top="'Renovación de socio bloqueada por situación de impago. Deben regularse los pagos para poder continuar'">Renovar</button></template>
            <template v-else-if="! familia.fecha_renovacion">
            <router-link :to="admin ? `/admin/familia/${familia.id}/renovar` : '/renovar'">
            <button type="button" class="btn btn-primary boton-renovar mt-3 mr-1">Renovar</button>
            </router-link>
            </template>

            <router-link :to="admin ? `/admin/familia/${familia.id}/editar` : '/editar'">
            <button type="button" class="btn btn-primary mt-3 mr-1">Editar datos</button>
            </router-link>

            <router-link :to="admin ? `/admin/familia/${familia.id}/balance` : '/cuentas'">
            <button type="button" class="btn btn-primary mt-3 mr-1">Ver cuentas</button>
            </router-link>

            </p>

          </div>
        </div>
      </div>

    </div>

    <div v-if="! admin" class="row">
      <div class="col-12">
        <div class="card mb-3">
          <div class="card-header">
            <h5>Información general</h5>
          </div>
          <div class="card-body">
            <p class="text-center">
            <router-link to="/extraescolares/horario">
              <button type="button" class="btn btn-primary mx-1 mt-1">Cuadro de extraescolares</button>
            </router-link>
            <router-link to="/extraescolares/normativa">
              <button type="button" class="btn btn-primary mx-1 mt-1">Normativa de extraescolares</button>
            </router-link>
            <router-link to="/contacto">
              <button type="button" class="btn btn-primary mx-1 mt-1">Contacto con el AMPA</button>
            </router-link>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="alert alert-primary" role="alert">
      <h4 class="alert-heading mb-0">Miembros de la familia</h4>
    </div>

    <div class="row">

      <div v-for="p in familia.miembros" class="col-12" :key="p.id">
        <div class="card detalles-persona mb-3">
          <div class="card-header bg-miembro text-white">
            <h5>{{ p.nombre }} {{ p.apellidos }}</h5>
            {{ p.nivel.nombre }} {{ p.nivel.clase }}
          </div>
          <div class="card-body">
            <template v-if="p.tipo == 'adulto'">
            <b>Rol:</b> {{ p.rol }}<br />
            </template>
            <template v-if="p.relacion">
            <b>Relación:</b> {{ p.relacion }}<br />
            </template>
            <template v-if="p.nif">
            <b>NIF:</b> {{ p.nif }}<br />
            </template>
            <template v-if="p.nacimiento">
            <b>Fecha de nacimiento:</b> {{ p.nacimiento }}<br />
            </template>
            <template v-if="p.email">
            <b>Email:</b> {{ p.email }}<br />
            </template>
            <template v-if="p.telefono1">
            <b>Teléfono 1:</b> {{ p.telefono1 }}<br />
            </template>
            <template v-if="p.telefono2">
            <b>Teléfono 2:</b> {{ p.telefono2 }}<br />
            </template>
    
            <template v-if="p.domicilio">
            <b>Domicilio:</b> {{ p.domicilio }}<br />
            </template>
            <template v-if="p.observaciones">
            <b>Observaciones:</b> {{ p.observaciones }}<br />
            </template>

            <p>
            <router-link :to="admin ? `/admin/persona/${p.id}/editar` : `/persona/${p.id}/editar`">
            <button type="button" class="btn btn-primary mt-3 mr-1">Editar persona</button>
            </router-link>
            <template v-if="familia.impago">
            <button type="button" class="btn btn-primary mt-3 boton-editar-actividades" title="Bloqueado" v-b-popover.click.top="'La inscripción a actividades está bloqueada por situación de impago'">Editar actividades</button>
            </template>
            <template v-else-if="familia.fecha_renovacion">
            <router-link :to="admin ? `/admin/persona/${p.id}/actividades` : `/actividades/${p.id}/editar`">
            <button type="button" class="btn btn-primary mt-3 boton-editar-actividades">Editar actividades</button>
            </router-link>
            </template>
            <template v-else>
            <button type="button" class="btn btn-primary mt-3 boton-editar-actividades" title="Bloqueado" v-b-popover.click.top="'La inscripción a actividades está bloqueada por falta de renovación de la subscripción anual'">Editar actividades</button>
            </template>
            <template v-if="admin">
            <router-link :to="`/admin/persona/${p.id}/actividades/avanzado`"><button type="button" class="btn btn-primary mt-3 ml-1 boton-editar-participaciones">Editar actividades (avanzado)</button></router-link>
            </template>
            <!--
            {% if usuario and usuario.id == p.id %}
            <button type="button" class="btn btn-primary mt-3 boton-cambiar-password">Cambiar contraseña</button>
            {% endif %}
            -->
            </p>

            <h5>Actividades</h5>

            <p class="text-center">
              <a href="javascript:void(0);" @click="periodoAnterior()">◁</a>&nbsp;&nbsp;<b>{{ periodo.nombre }}</b>&nbsp;&nbsp;<a href="javascript:void(0);" @click="periodoSiguiente()">▷</a>
            </p>
            <table class="table">
              <thead>
                <tr v-if="participacionesPeriodo(p.id).length < 1">
                  <td class="px-1 py-2 p-md-2 text-center" colspan="2"><i>Sin actividades en este período</i></td>
                </tr>
                <tr v-else>
                  <th class="px-1 py-2 p-md-2">Actividad</th>
                  <th class="px-1 py-2 p-md-2">Grupo</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(part, index) of participacionesPeriodo(p.id)" :key="index">
                  <td class="align-middle px-1 py-2 p-md-2">{{ actividades[part.id_actividad].nombre }}</td>
                  <td class="align-middle px-1 py-2 p-md-2">
                  <template v-if="'horas' in part">{{ part.horas | mostrarHoras }}</template>
                  <template v-else>{{ obtenerGrupo(part.id_actividad, part.id_grupo) }}</template>
                  </td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card detalles-persona mb-3">
          <div class="card-header">
            <h5><i>Añadir nuevo miembro</i></h5>
          </div>
          <div class="card-body">
            <p class="text-center mb-0">
            <router-link :to="admin ? `/admin/familia/${familia.id}/nuevo/adulto` : '/persona/nuevo/adulto'"><button type="button" class="btn btn-primary mb-2">Añadir adulto</button></router-link>
            <router-link :to="admin ? `/admin/familia/${familia.id}/nuevo/menor` : '/persona/nuevo/menor'"><button type="button" class="btn btn-primary mb-2 ml-1">Añadir menor</button></router-link>
            </p>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

import { api } from '../api/api.js';
import { obtenerCursoActivo, obtenerPeriodoActual } from '../curso.js';
import { convertirHoras } from '../utils.js';

export default {
	name: 'SociosFamilia',
	props: ['admin', 'id_familia'],
	data () {
		return {
			curso: null,
			periodo: null,

			familia: null,
			titular: null,

			actividades: null,
			participaciones: {},
		}
	},
	created () {
		this.curso = obtenerCursoActivo();
		this.periodo = obtenerPeriodoActual();
		this.obtenerFamilia();
		this.obtenerActividades();
	},
	computed: {
		periodoAbierto: function() {
			var abierto;
			for (let periodo of this.curso.periodos.values()) {
				if (periodo.estado == 1) {
					abierto = periodo;
					break;
				}
			}
			return abierto;
		}
	},
	methods: {
		preparado () {
			return (this.familia && this.actividades &&
				this.familia.miembros.length == Object.keys(this.participaciones).length
			);
		},
		obtenerFamilia () {
			const id_familia = this.id_familia ? this.id_familia : this.$parent.sesion.id_familia;
			api(`/familias/${id_familia}`)
				.then((data) => {
					if (data.resultado) {
						const familia = data.resultado;
						for (const m of familia.miembros) {
							this.obtenerParticipaciones(m.id);
							if (m.rol == 'titular') {
								this.titular = m;
							}
						}
						this.familia = familia;
					} else {
						// TODO: gestionar error
					}
				})
		},
		obtenerActividades () {
			api(`/actividades/${this.curso.id_curso}`)
                .then((data) => {
					if (data.resultado) {
						const actividades = {};
						for (const a of data.resultado) {
							actividades[a.id] = a;
						}
						this.actividades = actividades;
					}
				})
		},
		obtenerParticipaciones(id_persona) {
			api(`/personas/${id_persona}/actividades/${this.curso.id_curso}`)
				.then((data) => {
					this.$set(this.participaciones, id_persona, data.resultado);
				})
				.catch((error) => {
					console.log(error);
				});
		},
		obtenerGrupo(id_actividad, id_grupo) {
			const actividad = this.actividades[id_actividad];
			for (const g of actividad.grupos) {
				if (g.id == id_grupo) {
					return g.nombre;
				}
			}
			return '';
		},
		periodoAnterior() {
			for (let [i, periodo] of this.curso.periodos.entries()) {
				if (periodo.id_periodo == this.periodo.id_periodo) {
					if (i > 0) {
						this.periodo = this.curso.periodos[i-1];
					}
					break;
				}
			}
		},
		periodoSiguiente() {
			for (let [i, periodo] of this.curso.periodos.entries()) {
				if (periodo.id_periodo == this.periodo.id_periodo) {
					if (i < (this.curso.periodos.length - 1)) {
						this.periodo = this.curso.periodos[i+1];
					}
					break;
				}
			}
		},
		participacionesPeriodo(id_persona) {
			const participaciones = [];
			for (const part of this.participaciones[id_persona]) {
				if (part.periodos.includes(this.periodo.id_periodo)) {
					const part_periodo = {
						id_actividad: part.id_actividad,
						id_grupo: part.id_grupo,
					};
					if ('horas' in part && this.periodo.id_periodo in part.horas) {
						part_periodo.horas = part.horas[this.periodo.id_periodo];
					}
					participaciones.push(part_periodo);
				}
			}
			return participaciones;
		},
	},
	filters: {
		// FIXME: Repetido de SociosEditarActividades
		// TODO: Unificar con convertirHoras en utils
		mostrarHoras: function(listaHoras) {
			const convertidas = convertirHoras(listaHoras);
			return convertidas.join(', ');
			/*
			const hTxt = [];
			for (const h of listaHoras) {
				const dia = h.substring(0, 1);
				const hInicial = h.substring(2, 4) + ':' + h.substring(4, 6);
				let diaTxt;
				switch (dia) {
					case '1': diaTxt = 'L'; break;
					case '2': diaTxt = 'M'; break;
					case '3': diaTxt = 'X'; break;
					case '4': diaTxt = 'J'; break;
					case '5': diaTxt = 'V'; break;
				}
				hTxt.push(`${diaTxt} ${hInicial}`);
			}
			return hTxt.join(', ');
			*/
		},
	}
}
</script>

<style scoped>
.bg-miembro {
  background-color: #78b888;
}
</style>
